import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../..";   
import { GET_EMPLOYEES_LIST } from "../../Queries/Employees";

 
 
export const getEmployeesListThunk = createAsyncThunk(
  "employees/getEmployeesList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await client.query({
        query: GET_EMPLOYEES_LIST,
        fetchPolicy: "no-cache",
      });

      return response.data.getEmployeesList;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

 
const employeesSlice = createSlice({
  name: "employees",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getEmployeesListThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEmployeesListThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(getEmployeesListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default employeesSlice.reducer;
